import { computed } from 'vue';
import { useRoute } from 'nuxt/app';
import { useProductsStore } from '~~/common/stores/products';
import { isCategorySelectionFilterPath } from '~~/common/utils/pageType';

// Single source of truth for "should the hierarchical category filter be shown?".
// The same panel is rendered on desktop and mobile across all four list types;
// Options-API components pull this in via `setup: () => useCategorySelectionFilter()`.
// The route check is delegated to isCategorySelectionFilterPath.
export function useCategorySelectionFilter () {
  const route = useRoute();
  const productsStore = useProductsStore();

  const hasCategorySelectionFilter = computed(() => {
    return isCategorySelectionFilterPath(route) && Boolean(productsStore.getCategorySelectionFilter?.values?.length);
  });

  return {
    hasCategorySelectionFilter,
  };
}
